import { Space } from 'antd';
import { ColumnType } from '@/types';
import { DeleteButton } from '@/components/buttons/delete';
import { DeleteOutlined } from '@ant-design/icons';

export const getColumnsDomains = (
  translate: (key: string) => string,
  handleDeleteDomain: () => void,
  setDomainToDelete: (domain: string) => void,
  adminType?: string
): ColumnType[] => [
  {
    title: translate('system-config.domains.id'),
    key: 'id',
    dataIndex: 'id',
    render: (_, record, index) => index + 1,
  },
  {
    title: translate('system-config.domains.name'),
    dataIndex: 'whitelisted_domains',
    key: 'whitelisted_domains',
    render: (_, record) => record,
  },
  ...(adminType === 'SUPER_ADMIN'
    ? [
        {
          title: translate('system-config.domains.actions'),
          dataIndex: 'actions',
          key: 'actions',
          //@ts-ignore
          render: (_, record) => (
            <Space>
              <DeleteButton
                icon={<DeleteOutlined />}
                hideText
                size="small"
                recordItemId={record.id}
                confirmTitle={translate('system-config.domains.delete-confirm')}
                onClick={() => setDomainToDelete(record)}
                onConfirm={() => handleDeleteDomain()}
              />
            </Space>
          ),
        },
      ]
    : []),
];
